<template>
    <v-box element="div" v-if="excludeData.length > 0">
        <div class="v-properties">
            <h3 class="v-properties__title">Propiedades relacionadas</h3>
            <div class="v-properties__items">
                <router-link
                    :key="inx"
                    :title="out.title"
                    :to="`${path.toLowerCase()}/propiedad/${out.seoUrl}/${out.propertyHash}`"
                    class="v-properties__item"
                    v-for="(out, inx) in excludeData"
                >
                    <div class="v-properties__image">
                        <img :alt="out.title" :src="out.images[0].thumbnail" />
                    </div>
                    <div class="v-properties__caption">
                        <h4>{{ out.title.length > 60 ? `${out.title.substring(0, 60)}...` : out.title }}</h4>
                        <p>{{ operationProp(out.operation) }}</p>
                        <span>
                            <b>Precio:</b>
                            {{ out.currency }} {{ out.price }}
                        </span>
                    </div>
                </router-link>
            </div>
        </div>
    </v-box>
</template>

<script>
import operationNames from '../helpers/operationNames'
import { mapGetters, mapState } from 'vuex'

import { properties } from '@/services/ApiMapaprop'

export default {
    props: {
        exclude: {
            type: String,
            required: true
        },
        operation: {
            type: [Number, String],
            required: true
        },
        zone1: {
            type: [Number, String],
            required: false
        },
        zone2: {
            type: [Number, String],
            required: false
        },
        zone3: {
            type: [Number, String],
            required: false
        }
    },
    data() {
        return {
            data: []
        }
    },
    computed: {
        ...mapGetters({
            path: 'path'
        }),
        excludeData() {
            const exclude = this.data.filter((item) => item.code !== this.exclude)
            const images = exclude.filter((item) => item.images.length > 0)
            return images
        }
    },
    methods: {
        operationProp(operation) {
            const country = this.path.split('/')[1].toLowerCase()

            if (operation === 'Venta') operation = 1
            if (operation === 'Alquiler') operation = 2
            if (operation === 'Alquiler Temporario') operation = 3
            if (operation === 'Permuta') operation = 4
            if (operation === 'Traspaso') operation = 5
            if (operation === 'Compartir') operation = 6

            let result = ''

            operationNames[country].forEach((out, inx) => {
                if (out.value === operation) {
                    result = out.text
                }
            })

            return result
        },
        async READproperties() {
            const response = await properties({
                cityId: this.zone3,
                countyId: this.zone2,
                operation: this.operation,
                size: 6,
                stateId: this.zone1
            })

            this.data = response.data.properties
        }
    },
    created() {
        this.READproperties()
    }
}
</script>

<style lang="scss">
.v-properties {
    &__title {
        padding: 1rem;
        font-weight: 600;
    }
    &__items {
    }
    &__item {
        padding: 0.5rem 1rem;
        display: flex;
        border-top: 1px solid #d3d3d3;
        &:hover {
            background-color: #f3f3f3;
        }
    }
    &__image {
        height: 100px;
        width: 140px;
        margin-right: 1rem;
        img {
            height: 100%;
            width: 100%;
            object-fit: cover;
        }
    }
    &__caption {
        width: calc(100% - (140px + 1rem));
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        h4 {
            font-size: 0.9rem;
        }
        p {
            font-size: 0.8rem;
        }
        span {
            b {
                font-weight: 600;
                color: #c9d700;
            }
        }
    }
    @media (max-width: 576px) {
        &__title {
            text-align: center;
        }
        &__item {
            padding: 0.5rem 1rem;
            display: block;
            &:hover {
                background-color: #f3f3f3;
            }
        }
        &__image {
            height: 120px;
            width: 200px;
            margin-left: auto;
            margin-right: auto;
            margin-bottom: 1rem;
            img {
                height: 100%;
                width: 100%;
                object-fit: cover;
            }
        }
        &__caption {
            width: 100%;
            h4 {
                margin-bottom: 1rem;
                text-align: center;
            }
            span {
                text-align: center;
            }
        }
    }
}
</style>
